// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-werewolves/jira-space-dashboard-guide';

import { SpaceDashboardGuideSpotlight } from '../../../components/SpaceDashboardGuideSpotlight';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({ canEditDashboard }: RenderProps) => (
			<SpaceDashboardGuideSpotlight canEditDashboard={canEditDashboard} />
		),
	},
});
